export default __webpack_public_path__ + "static/media/19.22427d42.png";